export const index = function (state) {
  return state.index.sort(
    (a, b) => new Date(b.bestellingsdag) - new Date(a.bestellingsdag)
  );
};
